<template>
  <!---全体を囲む--->
  <div class="code-input-page">
    <!-- ヘッダー -->
    <TheHeader
      :header-title="masterBookSet ? masterBookSet.name : masterBook.name"
    />

    <!-- コード入力コンポーネント -->
    <TheCode0-9ButtonForm
      ref="TheCode09ButtonForm"
      :min-digit="8"
      @grandParentMethod1="changeOnetimeCode"
      @grandParentMethod2="validFrameWithCode"
    />

    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />

    <!-- 認証成功 -->
    <DialogOnetimeCodeComplete ref="DialogOnetimeCodeComplete" />

    <!-- 認証失敗 -->
    <DialogOnetimeCodeFails
      ref="DialogOnetimeCodeFails"
      @clearInputedCode="clearInputedCode"
    />
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import API from "@/API";

export default {
  name: "TemplateOneTimeCode",

  setup() {
    const store = useStore();

    const onetime_code = ref("");
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const masterBookSet = computed(
      () => store.getters["ticketing/masterBookSet"]
    );

    const TheCode09ButtonForm = ref(null);
    const DialogLoading = ref(null);
    const DialogOnetimeCodeComplete = ref(null);
    const DialogOnetimeCodeFails = ref(null);

    // コードの入力・削除が孫コンポーネントで起これば発火
    // データ(onetime_code)の書き換えを行う
    const changeOnetimeCode = (code) => {
      onetime_code.value = code;
    };

    const clearInputedCode = () => {
      TheCode09ButtonForm.value.clearInputedCode();
    };

    // データ(onetime_code)をリクエストパラメーターにPOST APIを発火
    const validFrameWithCode = async () => {
      // ローディングダイアログ表示
      DialogLoading.value.openDialog();

      try {
        await API.postCreateCouponBookGroup(null, `${onetime_code.value}`);

        // ローディングダイアログ削除
        DialogLoading.value.closeDialog();

        // 成功ダイアログ表示
        DialogOnetimeCodeComplete.value.openDialog();
      } catch (err) {
        // 失敗ダイアログ表示
        DialogLoading.value.closeDialog();
        DialogOnetimeCodeFails.value.openDialog();
      }
    };

    return {
      masterBook,
      masterBookSet,
      TheCode09ButtonForm,
      DialogLoading,
      DialogOnetimeCodeComplete,
      DialogOnetimeCodeFails,
      changeOnetimeCode,
      clearInputedCode,
      validFrameWithCode,
    };
  },
};
</script>

<style lang="scss" scoped>
.code-input-page {
  background: linear-gradient(#fcca09, #fde265);
  height: 100vh;
  width: 100vw;
}
</style>
